import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52107207"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative h-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "payment-element" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorButton = _resolveComponent("ColorButton")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.showPayButton)
        ? (_openBlock(), _createBlock(_component_ColorButton, {
            key: 0,
            text: _ctx.$t('pay'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.stripeCheckout($event))),
            class: "md:mt-8 sm:mt-4 forceWhite"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}